module.exports = __webpack_public_path__ + "static/lk-05027eb4dff8f920d9c2237ab14f223a.svg";